import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { parseSearchUrlParams } from "@/utils/searchParamsFormatter";
import useSearchStore from "@/stores/search.store";
import AppRoutes from "@/constants/routes/AppRoutes";

/**
 * GlobalSearchView - Shared search link handler
 *
 * When users open a shared search link (/search?searchQuery=...&filters=...),
 * this component:
 * 1. Parses the URL search params
 * 2. Populates the search store with the parsed search
 * 3. Opens the global search modal
 * 4. Redirects to the dashboard
 *
 * This allows shared search links to open the modal-based search experience
 * rather than a dedicated full-page search view.
 */
const GlobalSearchView = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setSearchQuery, setIsSearchbarOpen } = useSearchStore();

  useEffect(() => {
    // Parse URL params into search state
    const urlString = `${window.location.pathname}?${searchParams.toString()}`;
    const parsedSearch = parseSearchUrlParams(urlString);

    // Update search store with parsed search
    setSearchQuery(parsedSearch);

    // Open the search modal
    setIsSearchbarOpen(true);

    // Redirect to dashboard
    navigate(AppRoutes.dashboard, { replace: true });
  }, [searchParams, setSearchQuery, setIsSearchbarOpen, navigate]);

  // Return null - this component only handles the redirect
  // The user will see the dashboard with the search modal open
  return null;
};

export default GlobalSearchView;
